import moment from 'moment'
import { Row, Form } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { ProjectFormButtonContinue } from '../index'
import { FormLabels, CustomCol } from 'src/components'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { documentationSections } from './documentation-sections'
import { ProjectFormDocumentationPayload } from 'src/core/models'
import {
  documentationFormFilesValues,
  projectFormIsActiveSelector,
  documentationFormValues,
  setDocumentationPayload,
  setProjectFormItemValue,
  projectFormKindSelector,
} from 'src/features'

const ProjectFormDocumentation: React.FC = () => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const isActive = useAppSelector(projectFormIsActiveSelector)
  const kindSelected = useAppSelector(projectFormKindSelector)
  const fileValues = useAppSelector(documentationFormFilesValues)
  const sections = documentationSections(t, dispatch, fileValues, isActive, kindSelected)
  const formValues = useAppSelector(documentationFormValues)

  const onFinish = (values: ProjectFormDocumentationPayload) => {
    dispatch(setDocumentationPayload(values))
    dispatch(setProjectFormItemValue({ key: 'activeStep', value: 'CONFIGURATION' }))
  }

  useEffect(() => {
    form.setFieldsValue({
      ['registry_depositing_id']: formValues.registry_depositing_id,
      ['registry_depositing_name']: formValues.registry_depositing_name,
      ['registry_depositing_url']: formValues.registry_depositing_url,
      ['credits_certificate']: formValues.credits_certificate,
      ['pdd']: formValues.pdd,
      ['validation_report']: formValues.validation_report,
      ['monitoring_report']: formValues.monitoring_report,
      ['verification_report']: formValues.verification_report,
      ['device_registration_request']: formValues.device_registration_request,
      ['resulting_from_the_issuer']: formValues.resulting_from_the_issuer,
      ['start_up_date_of_installation']: formValues.start_up_date_of_installation && moment(new Date(formValues.start_up_date_of_installation)),
      ['protocol_implementation_scheme']: formValues.protocol_implementation_scheme,
      ['executive_summary']: formValues.executive_summary,
      ['additional_documentation']: formValues.additional_documentation,
      ['insurance_documentation']: formValues.insurance_documentation
    })
  }, [form, formValues])

  return (
    <Form
      onFinish={onFinish}
      form={form}
    >
      {sections.map((section, idx) => {
        if (!section.isVisible) return
        if (section.isOnlyComponent) return <section.form.component />
        return (
          <Row key={idx} className={section.rowClassName}>
            <CustomCol>
              <FormLabels {...section.labels} />
            </CustomCol>

            <CustomCol>
              <section.form.component {...section.form.props}/>
            </CustomCol>
          </Row>
        )
      })}
      <ProjectFormButtonContinue />
    </Form>
  )
}

export default ProjectFormDocumentation
